import { createReducer } from '../../utilities';
import {
    REQUEST_FETCH_STATS_LEAGUES,
    SUCCESS_FETCH_STATS_LEAGUES,
    FAIL_FETCH_STATS_LEAGUES,
} from "../../../actions/entities/statistics/leagues";

const initialState = {
    data: null,
    error: false,
    isFetching: false,
};

function requestFetch(state) {
    return {
        ...state,
        isFetching: true,
    };
}

function successFetch(state, action) {
    const { data } = action;
    return {
        ...state,
        data,
        isFetching: false,
    };
}

function failFetch(state, action) {
    const { error } = action;
    return {
        ...state,
        isFetching: false,
        error
    };
}

export default createReducer(initialState, {
    [REQUEST_FETCH_STATS_LEAGUES]: requestFetch,
    [SUCCESS_FETCH_STATS_LEAGUES]: successFetch,
    [FAIL_FETCH_STATS_LEAGUES]: failFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/statistics/leagues.js